export default "__VITE_ASSET__d75914ac__"